import { render } from "./code-editor.vue?vue&type=template&id=8a059818"
import script from "./code-editor.vue?vue&type=script&lang=js"
export * from "./code-editor.vue?vue&type=script&lang=js"

import "./code-editor.vue?vue&type=style&index=0&id=8a059818&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__